import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import en from 'src/locales/en'
import ja from 'src/locales/ja'
import ko from 'src/locales/ko'
import zhTw from 'src/locales/zh-TW'
import { I18NText, Language } from 'src/types'

export const useLocale = (): {
  locale: string
  t: I18NText
  isEn: boolean
  isKo: boolean
  isJa: boolean
  isZhTw: boolean
  isForeign: boolean
  language: Language
} => {
  // temporary
  const { locale } = useRouter()
  const isEn = locale === 'en'
  const isKo = locale === 'ko'
  const isJa = locale === 'ja'
  const isZhTw = locale === 'zh-TW'
  const isForeign = isEn || isKo || isZhTw
  const language = isEn ? 'en' : isKo ? 'ko' : isZhTw ? 'zh-TW' : 'ja'
  const t = isEn ? en : isKo ? ko : isZhTw ? zhTw : ja
  return { locale, t, isEn, isKo, isJa, isZhTw, isForeign, language }
}

export const useTransition = (modelPath: 'us' | 'korea'): { isFirstRendered: boolean } => {
  // const isFirstRendered = true
  const [isFirstRendered, setIsFirstRendered] = useState(false)
  const { locale, pathname, replace } = useRouter()

  useEffect(() => {
    const isInvalidSimulation = locale === 'ja' && !!modelPath && pathname.split('/').includes(modelPath)
    if (isInvalidSimulation) replace('/hard/atoms/japan')
    setIsFirstRendered(true)
  }, [])
  return { isFirstRendered }
}
